/* @ngInject */
export default function InstitutionEmailTemplateCtrl(

  InstitutionsManager,
) {
  const vm = this;

  vm.institution = InstitutionsManager.institution;
}
